import { render, staticRenderFns } from "./SocialSign.vue?vue&type=template&id=b7b4ac6a&"
import script from "./SocialSign.vue?vue&type=script&lang=ts&"
export * from "./SocialSign.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports